require(['app', 'controller', 'router', 'text!appconfig.json'], function(App, Controller, Router, Config){

	// Reading configuration parameters
	App.DeploymentProfile = $('.environment').attr('id');
	App.Config = $.parseJSON(Config)[App.DeploymentProfile];

	// Set the App router and controller
	App.Router = new Router({
		controller:new Controller()
	});

	// Start the App
	App.start();

});
define("main", function(){});

